export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCES";

export const SET_USER = "SET_USER";
export const SET_MYPLAYLIST = "SET_MYPLAYLIST";

export const SET_NEW_RELEASES_BROWSE = "SET_NEW_RELEASES_BROWSE";
export const SET_TOP_TRACKS = "SET_TOP_TRACKS";
export const SET_RECENTLY_PLAYED = "SET_RECENTLY_PLAYED";

export const SET_TOP_ARTISTS_BROWSE = "SET_TOP_ARTISTS_BROWSE";
export const SET_CURRENT_PLAYLIST = "SET_CURRENT_PLAYLIST";

export const SET_CURRENT_ALBUM = "SET_CURRENT_ALBUM";
export const SET_CURRENT_SEARCH = "SET_CURRENT_SEARCH";
